export const DefaultSources = {
  model_chat: 'model_chat',
  model_builder: 'model_builder',
  model_image_generator: 'model_image_generator',
  home_gallery: 'home_gallery',
  onboarding_pornhub: 'onboarding_pornhub',
  onboarding_instagram: 'onboarding_instagram',
  subscribe: 'subscribe',
  plans: 'plans',
  voice_message_free_plan_user: 'voice_message_free_plan_user',
} as const;